<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_members'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Advanced Filters Section -->
            <div class="filters-section mb-3 p-3 bg-light rounded">
              <div class="row align-items-end">
                <div class="col-md-4 col-sm-6">
                  <label class="form-label fw-bold">Date Range</label>
                  <div class="d-flex gap-2">
                    <input class="form-control form-control-sm" v-model="date_from" type="date" />
                    <input class="form-control form-control-sm" v-model="date_to" type="date" />
                  </div>
                </div>
                <div class="col-md-2 col-sm-6">
                  <label class="form-label fw-bold">Gender</label>
                  <select class="form-select form-select-sm" v-model="filterGender">
                    <option value="">All Genders</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div class="col-md-3 col-sm-6">
                  <label class="form-label fw-bold">Saving Package</label>
                  <v-select :options="savingpackages" placeholder="All Packages" 
                            v-model="filterPackage" label="name" 
                            :reduce="packagi => packagi.id" 
                            :clearable="true"
                            class="package-select"></v-select>
                </div>
                <div class="col-md-1 col-sm-3">
                  <label class="form-label fw-bold">&nbsp;</label>
                  <button class="btn btn-sm btn-primary w-100" @click="applyFilters">
                    <i class="mdi mdi-filter"></i> Filter
                  </button>
                </div>
                <div class="col-md-1 col-sm-3">
                  <label class="form-label fw-bold">&nbsp;</label>
                  <button class="btn btn-sm btn-secondary w-100" @click="clearAllFilters">
                    <i class="mdi mdi-filter-remove"></i> Clear
                  </button>
                </div>
                <div class="col-md-1 col-sm-3">
                  <label class="form-label fw-bold">&nbsp;</label>
                  <button class="btn btn-sm btn-info w-100" @click="toggleFilters">
                    <i :class="showFilters ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'"></i>
                    {{ showFilters ? 'Hide' : 'Show' }}
                  </button>
                </div>
              </div>

              <!-- Advanced Filters (Collapsible) -->
              <div v-show="showFilters" class="row mt-2 pt-2 border-top">
                <div class="col-md-3 col-sm-6">
                  <label class="form-label fw-bold">NIN</label>
                  <input class="form-control form-control-sm" v-model="filterNin" 
                         placeholder="Search by NIN..." />
                </div>
                <div class="col-md-3 col-sm-6">
                  <label class="form-label fw-bold">Church</label>
                  <input class="form-control form-control-sm" v-model="filterChurch" 
                         placeholder="Search by church..." />
                </div>
                <div class="col-md-3 col-sm-6">
                  <label class="form-label fw-bold">Username</label>
                  <input class="form-control form-control-sm" v-model="filterUsername" 
                         placeholder="Search by username..." />
                </div>
                <div class="col-md-3 col-sm-6">
                  <label class="form-label fw-bold">Sort By</label>
                  <select class="form-select form-select-sm" v-model="sortBy">
                    <option value="name">Name</option>
                    <option value="member_id">Member ID</option>
                    <option value="date_of_joining">Date Joined</option>
                    <option value="telephone">Phone Number</option>
                    <option value="created_at">Date Created</option>
                  </select>
                </div>
              </div>

              <!-- Active Filters Tags -->
              <div v-if="hasActiveFilters" class="mt-2">
                <span class="badge bg-primary me-1" v-for="(filter, key) in activeFilters" :key="key">
                  {{ filter.label }}: {{ filter.value }}
                  <i class="mdi mdi-close-circle ms-1" style="cursor: pointer;" 
                     @click="removeFilter(key)"></i>
                </span>
                <button class="btn btn-sm btn-outline-danger ms-2" @click="clearAllFilters">
                  Clear All
                </button>
              </div>
            </div>

            <!-- Table Controls -->
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <span class="d-flex justify-content-end mb-2">
              <router-link v-show="userData.permissions['new_member'] == 1" :to="{ path: '/newmember' }" type="button"
                class="fw-bold btn-sm btn btn-primary">
                <i class="mdi mdi-plus"></i> New Member</router-link>
              <export-excel class="btn btn-sm btn-info ms-1" :data="filteredMembers" name="SaccoMembers.xls"> 
                Export <i class="mdi mdi-download"></i>
              </export-excel>
              <button v-show="userData.permissions['new_member'] == 1" @click.prevent="upload"
                class="fw-bold btn btn-sm btn-success ms-1">
                <i class="mdi mdi-upload"></i> Import
              </button>
              <a v-show="userData.permissions['new_member'] == 1" download="new_members.csv"
                :href="getTemplate('new_members.csv')">
                <button class="fw-bold btn btn-sm btn-secondary ms-1">Template</button>
              </a>
            </span>

            <!-- Table -->
            <div class="table-responsive">
              <b-table :items="filteredMembers" :fields="Fields" responsive="sm" 
                :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" 
                @filtered="Filtered" :busy="IsBusy">
                
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>Loading Members...</strong>
                  </div>
                </template>

                <template #cell(index)="data">
                  {{ (currentPage - 1) * perPage + data.index + 1 }}
                </template>

                <template #cell(photo)="data">
                  <img v-if="data.item.member_photo" 
                       :src="data.item.member_photo" 
                       class="rounded-circle" width="50" height="50" 
                       :alt="data.item.name" />
                  <div v-else class="rounded-circle bg-light d-flex align-items-center justify-content-center" 
                       style="width: 50px; height: 50px; border: 1px solid #ddd;">
                    <i class="mdi mdi-account text-secondary" style="font-size: 24px;"></i>
                  </div>
                </template>

                <template #cell(name)="data">
                  {{ data.item.name }} <br />
                  <b class="text-info">{{ data.item.member_id }}</b>
                </template>

                <template #cell(nin)="data">
                  {{ data.item.nin }} <br />
                  <small><b>{{ data.item.age }}</b></small>
                </template>

                <template #cell(gender)="data">
                  <span :class="data.item.gender === 'Male' ? 'text-primary' : 'text-danger'">
                    {{ data.item.gender }}
                  </span>
                </template>

                <template #cell(telephone)="data">
                  0{{ data.item.telephone }}
                </template>

                <template #cell(nationality)="data">
                  {{ data.item.address }} <br>
                  <b class="text-primary">{{ data.item.nationality ? data.item.nationality.name : 'N/A' }}</b>
                </template>

                <template #cell(savingpackage)="data">
                  <span class="badge bg-info">{{ data.item.savingpackage ? data.item.savingpackage.name : 'N/A' }}</span>
                </template>

                <template #cell(sacco_member_id)="data">
                  {{ data.item.sacco_member_id || 'N/A' }}
                  <a :href="data.item.member_file" v-show="data.item.member_file!='0'" 
                     class="btn btn-sm btn-outline-info" target="_blank">
                    <i class="mdi mdi-file-excel"></i>
                  </a>
                </template>

                <template #cell(date_of_joining)="data">
                  {{ formatDate(data.item.date_of_joining) }}
                </template>

                <template #cell(actions)="data">
                  <div class="btn-group">
                    <router-link :to="{
                      path: '/memberprofile',
                      query: { id: data.item.member_id },
                    }" type="button" class="btn-sm btn btn-primary">
                      <i class="mdi mdi-clipboard-text"></i>
                    </router-link>
                    <b-button v-show="userData.permissions['edit_member'] == 1" 
                      @click="editMember(data.item)" type="button" class="btn-sm btn" 
                      variant="info" v-b-modal.edit>
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button v-show="userData.permissions['delete_member'] == 1"
                      @click="remove(data.item.id, data.item.name)" type="button" 
                      class="btn-sm btn" variant="danger" v-b-modal.delete>
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- Pagination -->
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalFiltered" 
                                  :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Permission -->
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to View Members</span>
            </center>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal id="edit-member" size="xl" centered title="Edit Member" title-class="font-14" hide-footer>
      <form @submit.prevent="updateMember">
        <div class="form-group mb-2">
          <input v-model="editId" type="hidden" />
          <div class="row">
            <div class="col-md-4">
              <label>Member Name <span class="text-danger">*</span></label>
              <input v-model="editName" type="text" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>Gender <span class="text-danger">*</span></label>
              <select class="form-control" v-model="editGender" required>
                <option>Female</option>
                <option>Male</option>
              </select>
            </div>
            <div class="col-md-4">
              <label>Telephone <span class="text-danger">*</span></label>
              <input v-model="editTelephone" type="text" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>NIN Number <span class="text-danger">*</span></label>
              <input v-model="editNin" type="text" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>Date Of Birth <span class="text-danger">*</span></label>
              <input v-model="editDateofbirth" type="date" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>Nationality <span class="text-danger">*</span></label>
              <v-select :options="countries" placeholder="Enter Nationality" 
                        v-model="editNationality" label="name"
                        :reduce="(nationality) => nationality.id"></v-select>
            </div>
            <div class="col-md-4">
              <label>Address <span class="text-danger">*</span></label>
              <input v-model="editAddress" type="text" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>Saving Package <span class="text-danger">*</span></label>
              <v-select :options="savingpackages" placeholder="Enter Saving Package" 
                        v-model="editSavingpackage" label="name" 
                        :reduce="(savingpackage) => savingpackage.id"></v-select>
            </div>
            <div class="col-md-4">
              <label>Next of Kin</label>
              <input v-model="editNokname" type="text" class="form-control" />
            </div>
            <div class="col-md-4">
              <label>Next of Kin Contact</label>
              <input v-model="editNokcontact" type="text" class="form-control" />
            </div>
            <div class="col-md-4">
              <label>Next of Kin Relation</label>
              <input v-model="editNokrelation" type="text" class="form-control" />
            </div>
            <div class="col-md-4">
              <label>Sacco Member Id</label>
              <input v-model="editSaccoMemberId" type="text" class="form-control" />
            </div>
            <div class="col-md-4">
              <label>Date of Joining <span class="text-danger">*</span></label>
              <input v-model="editDateOfJoining" type="date" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>Email Address <span class="text-danger">*</span></label>
              <input v-model="editEmail" type="email" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>Username <span class="text-danger">*</span></label>
              <input v-model="editUsername" type="text" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label>Church Name</label>
              <input v-model="editChurchname" type="text" class="form-control" />
            </div>
            <div class="col-md-4">
              <label>Member File</label>
              <input type="file" class="form-control" v-on:change="onLogoChange" accept=".xlsx, .xls, .csv" />
              <small v-if="editPreviousMemberFile != '0'">
                <a :href="editPreviousMemberFile" target="_blank" class="text-info">
                  <i class="mdi mdi-file-excel"></i> View Current File
                </a>
              </small>
            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-10">
                  <label>Member Photo</label>
                  <input type="file" class="form-control" v-on:change="onPhotoChange" accept=".png, .jpg, .jpeg" />
                </div>
                <div class="col-md-2">
                  <small v-if="editMemberPhoto">
                    <img :src="editMemberPhoto" class="rounded-circle" width="50" height="50" />
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-member')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <i class="fas fa-check-circle"></i> Update
          </b-button>
        </div>
      </form>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="delete-member" centered title="Delete Member" title-class="font-18" hide-footer>
      <form @submit.prevent="removeMember">
        <input v-model="deleteId" type="hidden" />
        <p>Are you sure you want to delete the Member: <b>{{ deleteName }}</b>?</p>
        <p class="text-danger"><small>This action cannot be undone!</small></p>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-member')">Cancel</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="danger">
            <i class="fas fa-trash"></i> Delete
          </b-button>
        </div>
      </form>
    </b-modal>

    <!-- Upload Modal -->
    <b-modal id="upload" centered title="Upload Members List" title-class="font-18" 
             :size="modalSize" hide-footer>
      <form @submit.prevent="addMembers">
        <div class="row p-0 align-items-center">
          <div v-if="members_file" class="p-0 col-1 text-danger" style="font-size: 100px;">
            !
          </div>
          <div v-if="members_file" class="p-0 fs-4 col">
            You are about to add New Members to your Sacco.
            <div v-if="members_file" class="fs-4 text-danger">
              Be sure about uploading this file.
            </div>
          </div>
        </div>
        <span v-if="upload_error" class="text-danger">{{ upload_error }}</span>
        <input type="file" @change.prevent="setFile" class="form-control" accept=".csv" />
        <br />
        <div v-if="error_message">
          <h4>The following errors occured:</h4>
          <div class="text-danger" v-for="(message, index) in error_message" :key="index">
            {{ message }}
          </div>
          <br />
        </div>
        <button type="submit" class="btn btn-sm btn-success fw-bold">
          Submit Members
        </button>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  memberMethods,
  memberComputed,
  savingpackageMethods,
  savingpackageComputed,
  countriesMethods,
  countriesComputed,
} from "@/state/helpers";
import moment from "moment";

export default {
  page: {
    title: "View Members",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Members",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "View Members", active: true },
      ],
      
      // Table settings
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 25, 50, 100, 150, 200],
      filter: null,
      filterOn: ['name', 'member_id', 'telephone', 'email', 'nin'],
      sortDesc: true,
      isBusy: true,
      
      // Fields configuration
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "photo", label: "Photo", visible: true },
        { key: "name", label: "Name", visible: true },
        { key: "nin", label: "NIN", visible: true },
        { key: "gender", label: "Gender", visible: true },
        { key: "telephone", label: "Contact", visible: true },
        { key: "nationality", label: "Nationality", visible: true },
        { key: "savingpackage", label: "Package", visible: true },
        { key: "username", label: "Username", visible: false },
        { key: "sacco_member_id", label: "Sacco ID", visible: true },
        { key: "date_of_joining", label: "Date of Joining", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],

      // Filter variables
      showFilters: false,
      date_from: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      date_to: moment().format('YYYY-MM-DD'),
      filterGender: "",
      filterPackage: null,
      filterNationality: null,
      filterMemberId: "",
      filterPhone: "",
      filterNin: "",
      filterChurch: "",
      filterAddedBy: "",
      filterUsername: "",
      filterHasPhoto: "",
      sortBy: "name",

      // Edit variables
      editId: "",
      editName: "",
      editGender: "",
      editTelephone: "",
      editNationality: "",
      editAddress: "",
      editDateofbirth: "",
      editNin: "",
      editDateOfJoining: "",
      editSaccoMemberId: "",
      editSavingpackage: "",
      editNokname: "",
      editNokcontact: "",
      editEmail: "",
      editUsername: "",
      editMemberFile: "",
      editMemberPhoto: "",
      editPreviousMemberFile: "",
      editChurchname: "",
      editNokrelation: "",

      // Delete variables
      deleteId: "",
      deleteName: "",

      // Upload variables
      members_file: "",
      upload_error: "",
      success_message: "",
      error_message: "",
    };
  },
  
  computed: {
  ...memberComputed,
  ...countriesComputed,
  ...savingpackageComputed,
  
  List() {
    return this.members.length;
  },
  
  Fields() {
    return this.fields.filter((field) => field.visible);
  },
  
  Items() {
    return this.members.map((d) => ({ ...d }));
  },
  
  IsBusy() {
    return this.members.length === 0;
  },
  
  modalSize() {
    return this.members_file ? "lg" : "";
  },

  // Filtered members with all filters applied
  filteredMembers() {
    let filtered = [...this.members];

    // Date range filter
    if (this.date_from && this.date_to) {
      filtered = filtered.filter(member => {
        const joinDate = moment(member.date_of_joining);
        return joinDate.isBetween(this.date_from, this.date_to, 'day', '[]');
      });
    }

    // Gender filter
    if (this.filterGender) {
      filtered = filtered.filter(member => 
        member.gender === this.filterGender
      );
    }

    // Package filter
    if (this.filterPackage) {
      filtered = filtered.filter(member => 
        member.savingpackage && member.savingpackage.id === this.filterPackage
      );
    }

    // Nationality filter
    if (this.filterNationality) {
      filtered = filtered.filter(member => 
        member.nationality && member.nationality.id === this.filterNationality
      );
    }

    // Member ID filter
    if (this.filterMemberId) {
      filtered = filtered.filter(member => 
        member.member_id && member.member_id.toLowerCase().includes(this.filterMemberId.toLowerCase())
      );
    }

    // Phone filter
    if (this.filterPhone) {
      filtered = filtered.filter(member => 
        member.telephone && member.telephone.includes(this.filterPhone)
      );
    }

    // NIN filter
    if (this.filterNin) {
      filtered = filtered.filter(member => 
        member.nin && member.nin.toLowerCase().includes(this.filterNin.toLowerCase())
      );
    }

    // Church filter
    if (this.filterChurch) {
      filtered = filtered.filter(member => 
        member.churchname && member.churchname.toLowerCase().includes(this.filterChurch.toLowerCase())
      );
    }

    // Username filter
    if (this.filterUsername) {
      filtered = filtered.filter(member => 
        member.username && member.username.toLowerCase().includes(this.filterUsername.toLowerCase())
      );
    }

    // Has photo filter
    if (this.filterHasPhoto === 'yes') {
      filtered = filtered.filter(member => member.member_photo && member.member_photo !== '0');
    } else if (this.filterHasPhoto === 'no') {
      filtered = filtered.filter(member => !member.member_photo || member.member_photo === '0');
    }

    // Sort
    if (this.sortBy) {
      filtered.sort((a, b) => {
        let valA = a[this.sortBy] || '';
        let valB = b[this.sortBy] || '';
        
        if (this.sortBy === 'date_of_joining' || this.sortBy === 'created_at') {
          return moment(valA).diff(moment(valB));
        }
        
        return valA.toString().localeCompare(valB.toString());
      });
    }

    // REMOVED: Don't modify data in computed property
    // this.totalFiltered = filtered.length;

    return filtered;
  },

  // Add a separate computed for total filtered count
  totalFiltered() {
    return this.filteredMembers.length;
  },

  // Active filters for display
  hasActiveFilters() {
    return Object.keys(this.activeFilters).length > 0;
  },

  activeFilters() {
    const filters = {};
    
    if (this.date_from && this.date_to) {
      filters.dateRange = {
        label: 'Date Range',
        value: `${this.date_from} to ${this.date_to}`
      };
    }
    if (this.filterGender) {
      filters.gender = {
        label: 'Gender',
        value: this.filterGender
      };
    }
    if (this.filterPackage) {
      const pkg = this.savingpackages.find(p => p.id === this.filterPackage);
      filters.package = {
        label: 'Package',
        value: pkg ? pkg.name : this.filterPackage
      };
    }
    if (this.filterNationality) {
      const country = this.countries.find(c => c.id === this.filterNationality);
      filters.nationality = {
        label: 'Nationality',
        value: country ? country.name : this.filterNationality
      };
    }
    if (this.filterMemberId) {
      filters.memberId = {
        label: 'Member ID',
        value: this.filterMemberId
      };
    }
    if (this.filterPhone) {
      filters.phone = {
        label: 'Phone',
        value: this.filterPhone
      };
    }
    if (this.filterNin) {
      filters.nin = {
        label: 'NIN',
        value: this.filterNin
      };
    }
    if (this.filterChurch) {
      filters.church = {
        label: 'Church',
        value: this.filterChurch
      };
    }
    if (this.filterHasPhoto) {
      filters.hasPhoto = {
        label: 'Has Photo',
        value: this.filterHasPhoto === 'yes' ? 'Yes' : 'No'
      };
    }
    return filters;
  },
},

  mounted() {
    this.fetchCountries();
    this.fetchMembers();
    this.fetchSavingPackages();
    this.TotalRows = this.members.length;
    this.isBusy = false;
  },

  methods: {
    ...memberMethods,
    ...countriesMethods,
    ...savingpackageMethods,

    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : 'N/A';
    },

    toggleFilters() {
      this.showFilters = !this.showFilters;
    },

    applyFilters() {
      this.currentPage = 1;
      // Filter already applied via computed property
    },

    clearAllFilters() {
      this.date_from = moment().subtract(90, 'days').format('YYYY-MM-DD');
      this.date_to = moment().format('YYYY-MM-DD');
      this.filterGender = "";
      this.filterPackage = null;
      this.filterNationality = null;
      this.filterMemberId = "";
      this.filterPhone = "";
      this.filterNin = "";
      this.filterChurch = "";
      this.filterAddedBy = "";
      this.filterUsername = "";
      this.filterHasPhoto = "";
      this.sortBy = "name";
      this.filter = null;
      this.currentPage = 1;
    },

    removeFilter(key) {
      switch(key) {
        case 'dateRange':
          this.date_from = moment().subtract(90, 'days').format('YYYY-MM-DD');
          this.date_to = moment().format('YYYY-MM-DD');
          break;
        case 'gender':
          this.filterGender = "";
          break;
        case 'package':
          this.filterPackage = null;
          break;
        case 'nationality':
          this.filterNationality = null;
          break;
        case 'memberId':
          this.filterMemberId = "";
          break;
        case 'phone':
          this.filterPhone = "";
          break;
        case 'nin':
          this.filterNin = "";
          break;
        case 'church':
          this.filterChurch = "";
          break;
        case 'hasPhoto':
          this.filterHasPhoto = "";
          break;
      }
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onLogoChange(e) { 
      this.editMemberFile = e.target.files[0]; 
    },

    onPhotoChange(e) { 
      this.editMemberPhoto = e.target.files[0]; 
    },

    editMember(item) {
      this.editId = item.id;
      this.editName = item.name;
      this.editGender = item.gender;
      this.editTelephone = item.telephone;
      this.editNationality = item.nationality ? item.nationality.id : null;
      this.editAddress = item.address;
      this.editDateofbirth = item.date_of_birth;
      this.editNin = item.nin;
      this.editDateOfJoining = item.date_of_joining;
      this.editSaccoMemberId = item.sacco_member_id;
      this.editSavingpackage = item.savingpackage ? item.savingpackage.id : null;
      this.editNokname = item.nokname;
      this.editNokcontact = item.nokcontact;
      this.editEmail = item.email;
      this.editUsername = item.username;
      this.editPreviousMemberFile = item.member_file;
      this.editMemberPhoto = item.member_photo;
      this.editChurchname = item.churchname;
      this.editNokrelation = item.nokrelation;
      this.$bvModal.show("edit-member");
    },

    async updateMember() {
      let formData = new FormData();
      formData.append("id", this.editId);
      formData.append("name", this.editName);
      formData.append("gender", this.editGender);
      formData.append("telephone", this.editTelephone);
      formData.append("nationality", this.editNationality);
      formData.append("address", this.editAddress);
      formData.append("dateofbirth", this.editDateofbirth);
      formData.append("nin", this.editNin);
      formData.append("date_of_joining", this.editDateOfJoining);
      formData.append("sacco_member_id", this.editSaccoMemberId);
      formData.append("nokname", this.editNokname);
      formData.append("nokcontact", this.editNokcontact);
      formData.append("savingpackage", this.editSavingpackage);
      formData.append("email", this.editEmail);
      formData.append("username", this.editUsername);
      formData.append("churchname", this.editChurchname);
      formData.append("nokrelation", this.editNokrelation);
      
      if (this.editMemberFile) {
        formData.append("member_file", this.editMemberFile);
      }
      if (this.editMemberPhoto && typeof this.editMemberPhoto !== 'string') {
        formData.append("member_photo", this.editMemberPhoto);
      }

      let url = "/updatemember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMembers();
          this.$bvModal.hide("edit-member");
          this.$toast.success("Member updated successfully!");
        }
      });
    },

    remove(id, name) {
      this.deleteId = id;
      this.deleteName = name;
      this.$bvModal.show("delete-member");
    },

    async removeMember() {
      let formData = new FormData();
      formData.append("id", this.deleteId);
      let url = "/removemember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMembers();
          this.$bvModal.hide("delete-member");
          this.$toast.success("Member deleted successfully!");
        }
      });
    },

    upload() {
      this.upload_error = "";
      this.members_file = "";
      this.error_message = "";
      this.$bvModal.show("upload");
    },

    setFile(event) {
      this.upload_error = "";
      this.members_file = event.target.files[0];
    },

    async addMembers() {
      const config = { headers: { "content-type": "multipart/form-data" } };
      if (!this.members_file) {
        this.upload_error = "No File Selected!";
        return;
      }

      let url = "add_via_csv";
      let formData = new FormData();
      formData.append("members", this.members_file);
      
      try {
        const response = await axios.post(url, formData, config);
        if (response.status == 200) {
          this.success_message = response.data.message;
          this.$bvModal.hide("upload");
          this.$toast.success(this.success_message);
          this.fetchMembers();
        }
        if (response.status == 201) {
          this.error_message = response.data.errors;
        }
      } catch (error) {
        this.$toast.error("Error uploading members. Please try again.");
      }
    },

    getTemplate(name) {
      let url = axios.defaults.baseURL;
      let templateLink = url.slice(0, -3) + `templates/${name}`;
      return templateLink;
    },
  },
};
</script>

<style scoped>
.filters-section {
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.filters-section .row {
  margin-left: 0;
  margin-right: 0;
}

.filters-section .row > div {
  padding-left: 5px;
  padding-right: 5px;
}

.form-label {
  font-size: 0.85rem;
  margin-bottom: 2px;
}

.badge {
  font-size: 0.8rem;
  padding: 5px 10px;
}

.package-select >>> .vs__dropdown-toggle,
.country-select >>> .vs__dropdown-toggle {
  min-height: 31px;
  font-size: 0.875rem;
}

.package-select >>> .vs__search,
.country-select >>> .vs__search {
  min-height: 29px;
  padding: 0 8px;
}

.btn-group .btn-sm {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.table-responsive {
  min-height: 400px;
}

@media (max-width: 768px) {
  .filters-section .row > div {
    margin-bottom: 8px;
  }
  
  .btn-sm {
    font-size: 0.7rem;
  }
}
</style>